import axios from 'axios'

import { ReportDataIssueContextType } from '../../../constants/events'
import {
  COP_API_BASE_URL,
  REPORT_ASSET_DATA_ISSUE_ENDPOINT,
  REPORT_SITE_DATA_ISSUE_ENDPOINT,
} from '../../../constants/service-endpoints'
import { buildCopHeaders, getSilentToken } from '../../../services/tokenUtils'

export type ReportDataIssueRequest = {
  contextType: ReportDataIssueContextType
  contextId: string
  description: string
  issueCategories: string[]
}

type ReportDataIssuePayload = {
  description: string
  issueCategories: string[]
} & ({ assetId: string } | { siteId: string })


function getReportDataIssueEndpoint(contextType: ReportDataIssueContextType): string {
  return contextType === 'site'
    ? REPORT_SITE_DATA_ISSUE_ENDPOINT
    : REPORT_ASSET_DATA_ISSUE_ENDPOINT
}

export async function reportDataIssue({
  contextType,
  contextId,
  description,
  issueCategories,
}: ReportDataIssueRequest): Promise<void> {
  const payload: ReportDataIssuePayload = contextType === 'site'
    ? {
        siteId: contextId,
        description,
        issueCategories,
      }
    : {
        assetId: contextId,
        description,
        issueCategories,
      }


  try {
    const token = getSilentToken()
    const endpoint = getReportDataIssueEndpoint(contextType)
    const url = `${COP_API_BASE_URL}${endpoint}`
    const headers = buildCopHeaders(token);
    await axios.post(url,{payload}, { headers });
  } catch {
    throw new Error('Failed to report data issue. Please try again.')
  }
}
